import React from 'react';

const SmallRightArrowCircle = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='12' fill='#F5F6F7' />
      <path
        d='M9.30005 15.625L12.7219 12.2812L9.30005 8.95312L10.2375 8L14.6438 12.2812L10.2375 16.5781L9.30005 15.625Z'
        fill='#8D9297'
      />
    </svg>
  );
};

export default SmallRightArrowCircle;
